import { Flex, Heading, Text } from "@instructure/ui";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { ExternalService } from "../../../../../../services/ExternalService";
import {
  ERROR,
  useNotification,
} from "../../../../../CustomHooks/NotificationProvider";
import NonStructuredQuestions from "./NonStructuredQuestions";
import StructuredQuestions from "./StructuredQuestions";

const QualitativeMeasure = ({ measure, permission, isPreview, userEmail }) => {
  const { t } = useTranslation();
  const showNotification = useNotification();
  const [structuredQuestions, setStructuredQuestions] = useState(null);
  const [instructions, setInstructions] = useState(null);

  const hasStructuredQuestions =
    Array.isArray(structuredQuestions) && structuredQuestions.length > 0;

  const isLoading = instructions === null || structuredQuestions === null;

  useEffect(() => {
    const fetchStructuredQuestions = async () => {
      try {
        const questions = await ExternalService.getStructuredQuestions(
          measure.ddl_id
        );
        setStructuredQuestions(questions);
      } catch {
        setStructuredQuestions([]);
      }
    };

    fetchStructuredQuestions();
  }, [measure.ddl_id]);

  useEffect(() => {
    const getInstructions = async () => {
      try {
        const measureInstructions = await ExternalService.getFileContent(
          "response.html",
          "qualitativeMeasure",
          measure.ddl_id
        );
        setInstructions(measureInstructions.content);
      } catch {
        setInstructions("");
        showNotification(
          t("notifications.assessmentResults.getMeasureError"),
          ERROR
        );
      }
    };

    getInstructions();
  }, [measure.ddl_id, showNotification]);

  // Show skeleton while loading structured questions determination
  if (isLoading) {
    return (
      <Flex wrap="wrap" gap="small">
        <Flex.Item size="100%">
          <Flex wrap="wrap" gap="small" alignItems="center">
            <Flex.Item>
              <Heading level="h3">{measure.name}</Heading>
            </Flex.Item>
            {!isPreview && (
              <Flex.Item>
                <Text fontStyle="italic">
                  {t("measures.assignedTo")}: {measure.assignees}
                </Text>
              </Flex.Item>
            )}
          </Flex>
        </Flex.Item>
        <Flex.Item shouldGrow>
          <Skeleton height="10rem" count={2} style={{ marginBottom: 10 }} />
        </Flex.Item>
      </Flex>
    );
  }

  return hasStructuredQuestions ? (
    <StructuredQuestions
      measure={measure}
      instructions={instructions}
      userEmail={userEmail}
      isPreview={isPreview}
      permission={permission}
      structuredQuestions={structuredQuestions}
    />
  ) : (
    <NonStructuredQuestions
      measure={measure}
      instructions={instructions}
      userEmail={userEmail}
      isPreview={isPreview}
      permission={permission}
    />
  );
};

export default QualitativeMeasure;
